export enum PaymentPlanStatusText {
    PEN = 'Pendiente',
    PAY = 'Pagado',
    UNP = 'No pagado',
    PRO = 'En curso'
};

export enum PaymentPlanStatus {
    PEN = 'PEN',
    PAY = 'PAY',
    UNP = 'UNP',
    PRO = 'PRO'
};

export interface PaymentPlanData {
    order: number;
    start_date: string;
    end_date: string;
    amount: number;
    state: PaymentPlanStatus;
    collected: number;
}

export interface PaymentPlanParams {
    loan_id: string;
    installment: number;
    term: number;
    payment_day: number;
}


export interface SimulationResponse {
    simulation_payments: SimulationData[];
}

export interface SimulationData {
    term: number;
    installment: number;
}

export interface SimulationPaymentPlan {
    term: number;
    installment: number;
    month_day: number;
}

export interface PaymentPlanDetailRow {
    order: number;
    date: string;
    quota: string;
    status?: PaymentPlanStatus;
}